import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const PasswordErrorMap = {
  INVALID_PASSWORD_FORMAT: 40015,
  NEW_PASSWORD_SAME_AS_OLD: 40016,
  PASSWORD_TOO_SHORT: 40018,
  PASSWORD_TOO_LONG: 40019,
  PASSWORD_ILLEGAL_REPEAT: 40024,
  PASSWORD_ILLEGAL_QWERTY: 40026,
  PASSWORD_ILLEGAL_NUMERIC: 40027,
  PASSWORD_ILLEGAL_ALPHABETICAL: 40028,
  PASSWORD_ILLEGAL_SEQUENCE: 40029,
};

export const PasswordErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    PasswordErrorMap.INVALID_PASSWORD_FORMAT,
    {
      errorCode: PasswordErrorMap.INVALID_PASSWORD_FORMAT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.NEW_PASSWORD_SAME_AS_OLD,
    {
      errorCode: PasswordErrorMap.NEW_PASSWORD_SAME_AS_OLD,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.PASSWORD_TOO_SHORT,
    {
      errorCode: PasswordErrorMap.PASSWORD_TOO_SHORT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
      openModal: false,
    },
  ],
  [
    PasswordErrorMap.PASSWORD_TOO_LONG,
    {
      errorCode: PasswordErrorMap.PASSWORD_TOO_LONG,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],

  [
    PasswordErrorMap.PASSWORD_ILLEGAL_QWERTY,
    {
      errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_QWERTY,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.PASSWORD_ILLEGAL_NUMERIC,
    {
      errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_NUMERIC,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.PASSWORD_ILLEGAL_ALPHABETICAL,
    {
      errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_ALPHABETICAL,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.PASSWORD_ILLEGAL_SEQUENCE,
    {
      errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_SEQUENCE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
  [
    PasswordErrorMap.PASSWORD_ILLEGAL_REPEAT,
    {
      errorCode: PasswordErrorMap.PASSWORD_ILLEGAL_REPEAT,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PASSWORD,
      callBack: () => {},
    },
  ],
]);
